import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as settingActions from '../store/actions/settings.actions';

@Injectable()
export class ThirdPartiesNedapResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve() {
    // (Re)Load when on /settings/barn
    this.store.dispatch(settingActions.loadNedapInstallationsRequest());

    return of(true);
  }
}
